const SLOVAK_REGION_LABELS: Record<string, string> = {
    bratislavsky: 'Bratislavský kraj',
    trnavsky: 'Trnavský kraj',
    trenciansky: 'Trenčiansky kraj',
    nitriansky: 'Nitriansky kraj',
    zilinsky: 'Žilinský kraj',
    banskobystricky: 'Banskobystrický kraj',
    presovsky: 'Prešovský kraj',
    kosicky: 'Košický kraj'
}

export function formatSlovakRegionLabel(value: unknown): string {
    const region = sanitizeText(value)
    if (!region) return ''

    const mappedRegion = SLOVAK_REGION_LABELS[toRegionLookupKey(region)]
    if (mappedRegion) return mappedRegion

    if (/kraj/i.test(region)) return region

    return `${region} kraj`
}

function sanitizeText(value: unknown): string {
    return typeof value === 'string' ? value.trim() : ''
}

function toRegionLookupKey(value: string): string {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\bkraj\b/gi, '')
        .toLowerCase()
        .replace(/[^a-z]/g, '')
}
